"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHIMMERING_TEXT_CLASSES = void 0;
exports.default = ThinkingStep;
exports.thinkingTitle = thinkingTitle;
exports.withoutParagraphIds = withoutParagraphIds;
var _collapsible = require("@design/ui/collapsible");
var _materialSymbols = require("@design/icons/material-symbols");
var _utils = require("@design/lib/utils");
var _ooxmlNames = require("@common/utils/redline/ooxml/ooxml-names");
var _jsxRuntime = require("react/jsx-runtime");
var THINKING_PLACEHOLDER_TITLE = "Thinking";
var MARKDOWN_SYNTAX_MARKERS = /[*#`]/g;
var SNAKE_CASE_WORD_SEPARATORS = /_+/g;
var RUN_OF_SPACES = / {2,}/g;
var SHIMMERING_TEXT_CLASSES = exports.SHIMMERING_TEXT_CLASSES = "bg-linear-to-r from-foreground-disabled from-35% via-foreground-primary via-50% to-foreground-disabled to-65% bg-[length:200%_100%] bg-clip-text text-transparent animate-thinking-shimmer";
function withoutParagraphIds(text) {
  return text.replace(_ooxmlNames.PARAGRAPH_BOOKMARK_NAME_IN_PROSE, "a paragraph");
}
function readableTitleLine(line) {
  return line.replace(MARKDOWN_SYNTAX_MARKERS, "").replace(SNAKE_CASE_WORD_SEPARATORS, " ").replace(RUN_OF_SPACES, " ").trim();
}
function thinkingTitle(text) {
  var firstLine = text.split("\n").map(readableTitleLine).find(function (line) {
    return line.length > 0;
  });
  return firstLine !== null && firstLine !== void 0 ? firstLine : THINKING_PLACEHOLDER_TITLE;
}
function ThinkingStep(_ref) {
  var text = _ref.text,
    isThinking = _ref.isThinking;
  var readableThinking = withoutParagraphIds(text);
  var title = /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: (0, _utils.cn)("truncate", isThinking ? SHIMMERING_TEXT_CLASSES : "text-foreground-muted"),
    children: thinkingTitle(readableThinking)
  });
  var fullThinking = /*#__PURE__*/(0, _jsxRuntime.jsx)(_collapsible.CollapsibleContent, {
    className: "mt-1 whitespace-pre-wrap border-l border-border-subtle pl-3 text-xs leading-relaxed text-foreground-muted",
    children: readableThinking
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_collapsible.Collapsible, {
    className: "group/thinking mb-2 max-w-[95%] text-sm",
    "data-testid": "thinking-step",
    "data-sentry-element": "Collapsible",
    "data-sentry-component": "ThinkingStep",
    "data-sentry-source-file": "ThinkingStep.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_collapsible.CollapsibleTrigger, {
      className: "flex max-w-full min-w-0 items-center gap-1 text-left text-foreground-muted hover:text-foreground-primary",
      "aria-label": isThinking ? "Thinking, show reasoning" : "Show reasoning",
      "data-sentry-element": "CollapsibleTrigger",
      "data-sentry-source-file": "ThinkingStep.tsx",
      children: [title, /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ChevronRightIcon, {
        className: "shrink-0 transition-transform group-data-[state=open]/thinking:rotate-90",
        "data-sentry-element": "ChevronRightIcon",
        "data-sentry-source-file": "ThinkingStep.tsx"
      })]
    }), fullThinking]
  });
}